import InputFieldsGenerator from 'components/InputFieldsGenerator';
import { InputProps } from 'components/InputFieldsGenerator/types';
import React from 'react';

const LocationFormBasic: React.FC<{ inputProps: InputProps[] }> = ({ inputProps }) => (
  <div className='p-4'>
    <InputFieldsGenerator formFields={inputProps} />
  </div>
);

export default React.memo(LocationFormBasic);
